export const ACCEPT_TYPE = 'application/pdf'; // PDF 格式
export const MAX_SIZE_M = Number(process.env.NEXT_PUBLIC_PDF_MAX_SIZE);
export const MAX_UPLOAD_FILES = 100; // 单次上传最大个数
export const QRCONNECT_APPID = 'wxcde858c8a166f0fa';
export const AUTHORIZE_APPID = 'wx370cbf3136b3481f';
export const DEFAULT_MAX_PAGE_SIZE = 100;
export const DEFAULT_PAGE_SIZE = 100;
export const DEFAULT_PAGE_SIZE_LIST = [100];